import { doGETRequest , doPUTRequest, doPOSTRequest} from "./Api";

class DashboardApi {

   public static async userCount() {
    const relativePath = "/dashboard/user-count";
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async buyerCount() {
      const relativePath = "/dashboard/buyer-count";
      var response = await doGETRequest(relativePath);
      return response;
    }

     public static async warehouseCount() {
        const relativePath = "/dashboard/warehouse-count";
        var response = await doGETRequest(relativePath);
        return response;
      }

      public static async listingProductCount() {
          const relativePath = "/dashboard/listing-product-count";
          var response = await doGETRequest(relativePath);
          return response;
        }

        public static async productItemCount() {
                  const relativePath = "/dashboard/product-item-count";
                  var response = await doGETRequest(relativePath);
                  return response;
                }
  public static async orderCount() {
          const relativePath = "/dashboard/order-count";
          var response = await doGETRequest(relativePath);
          return response;
        }

        public static async basketCount() {
                  const relativePath = "/dashboard/basket-count";
                  var response = await doGETRequest(relativePath);
                  return response;
                }

}

export default DashboardApi;
